<template>
  <br />
  <div class="oddRoundElement">
    <p class="textTitalIndentation">尊敬的用户：</p>
    <p class="text2DIndentation">您好！本协议由合作机构用户与中科知心平台（任何域名中包含“zkzhixin.cn”的网站，均属北京云腾优仕科技有限公司所有并由其负责运营的平台；以下简称“平台”）技术支持方北京云腾优仕科技有限公司（以下简称“技术方”）订立，在用户与平台之间具有与合同同等的法律效力。本协议条款构成您使用平台提供的服务或使用“中科知心”应用的前提条件，运营方再次特别提醒用户在正式使用平台功能前，请审慎阅读本协议各条款，特别是有关运营方责任与免责、对用户权利限制的条款，并选择接受或不接受本协议。用户确认其所做出的意思表示及应用上的所有操作行为（包括下载、安装、启动、浏览、注册、绑定、登陆、使用等）均代表您同意本协议的全部条款。<strong>若用户不同意本协议，或对本协议的条款存在任何疑问，用户应停止使用平台功能并以平台公示的联系方式联系平台。</strong></p>
    <p class="text2DIndentation"><strong>本协议内容包括协议正文、《隐私政策》等及所有中科知心软件或平台已经发布的各类规则均为本协议不可分割的一部分，与本协议正文具有同等法律效力，</strong>如本协议个别条款被有管辖权的法院认定为无效的，不影响其他条款的效力。</p>
    <p class="text2DIndentation">在您接受本协议之前，本协议可能因国家政策、产品与服务以及履行本协议的环境发生变化而进行修改，修改后的协议、本平台相关规则、服务规范、服务形式等，发布或公示在中科知心应用或平台的适当位置。<strong>经修订的协议或平台规则在中科知心或在平台发布后，我们会及时通知您更改内容，并请您仔细阅读，理解并接受更新后的协议或平台规则，如您不同意相关变更，请停止使用中科知心或平台的产品或服务。</strong></p>
    <p class="text2DIndentation"><strong>本协议中与您的权益（可能）存在重大关系的条款，我们已采用加粗字体来特别提醒您，请留意重点查阅。您不应以平台未尽合理提示等异物而声称协议中的条款非法或无效。</strong>如您在阅读本协议过程中有任何疑惑或其他相关事宜，请随时与我们保持联系，云腾优仕科技或平台将尽快为您做出解答或响应。</p>   
    <p class="textIndentation"><strong>第一条 释义</strong></p>
    <p class="text2DIndentation">1.1除本协议另有约定外，本协议中下列有关用语具有如下含义：</p>
    <p class="textIndentation">（1）中科知心平台：指由北京云腾优仕科技有限公司投资并运营的提供信息服务的专业性网站（任何域名中包含“zkzhixin.cn”的网站，均属北京云腾优仕科技有限公司所有并由其负责运营的平台），仅为用户查看、发布、处理交易信息的科技平台。</p>
    <p class="textIndentation">（2）中科知心：指平台旗下专门运营【    】的手机应用软件。</p>
    <p class="textIndentation">（3）用户及用户账户：指接受并同意本协议及平台的业务规则和指引，通过中科知心软件或平台注册要求进行平台注册，或通过微信公共号绑定并成功获得平台登录唯一用户名，使用中科知心软件或平台服务用户的简称。<strong>未在中科知心或平台注册的用户，自下载或安装其他第三方产品与服务时及自动成为中科知心的“非注册用户”，需遵守本协议用户注册规定义务外的其他所有条款。</strong></p>
    <p class="textIndentation">（4）合作机构：通过平台或中科知心进行信息交互，为平台用户提供健康服务的医疗健康提供方，包括但不限于公立医院、民营医疗主体等。</p>
    <p class="textIndentation">（5）健康管理客户：通过平台或中科知心的信息交互，申请健康分析和健康管理服务的申请人。</p>
    <p class="textIndentation">（6）交易：用户通过或中科知心或平台提供的信息进行的交易活动，形成交易关系，并通过或中科知心与其他方确认交易记录。</p>
    <p class="textIndentation">（7）业务规则和指引：指平台及/或中科知心发布的届时有效的各项业务规则、操作流程、通知通告、使用说明和指引等文件，以及其不时被更新、替换、补充、修订的版本。业务规则和指引应视为本协议重要的一部分。</p>
    <p class="textIndentation">（8）操作：指用户进行机构绑定、注册、认证资料上传、业务申请、产品服务签约购买、合作机构保证金支付、数据分析结果查询和合作机构其他业务预约等用户账户管理、运作、维护事宜。平台仅对用户在平台及/或中科知心上的所有操作进行记录，用于用户查询。</p>
    <p class="textIndentation">（9）电子认证服务机构：指接受平台及/或中科知心的委托，协助平台办理用户认证并为认证通过的用户签发电子签名认证证书的服务机构。</p>
    <p class="textIndentation">（10）电子签名：指《中华人民共和国电子签名法》所规定的电子签名，是指数据电文中以电子形式所含、所附用于识别签名人身份并表明签名人认可其中内容的数据。</p>
    <p class="textIndentation">（11）电子合同：指在平台及/或中科知心运营过程中，用户以电子认证服务机构颁发的与平台绑定的数字证书在平台上通过点击确认或类似方式签署的数据电文，形式包括但不限于协议书、知情同意书、保证函、单方确认等。用户通过前述方式订立的电子合同对合同各方具有法律约束力。</p>
    <p class="textIndentation"><strong>第二条 服务简介</strong></p>
    <p class="textIndentation">2.1平台通过中科知心（含APP及其他登录客户端或平台网络页面链接HTML）为用户提供互联网信息服务。</p>
    <p class="textIndentation">2.2<strong>用户理解并同意平台有权基于业务功能、使用规则、法律法规及监管要求、更好的提供服务、经营策略等原因，对本协议、《隐私及信息保护政策》、各项业务规则和指引、用户服务的项目和内容不时进行更新，用户可以在相关服务页面查阅上述文件的最新版本。上述文件更新后，如果用户继续使用平台服务，即视为用户已接受修改后的上述文件。如果用户不接受更新后的上述文件相关内容，原交易项下其权利义务不变，但用户应及时停止使用本平台，不得开展后续其他交易。</strong></p>
    <p class="textIndentation">2.3平台及/或中科知心（以下简称“中科知心”）通过应用软件、微信公众号以及其他渠道和方式等向用户提供以下服务中的一项或多项：</p>
    <p class="textIndentation">（1）为用户的信息交互提供平台及服务系统；</p>
    <p class="textIndentation">（2）基于合作机构提供的数据，进行健康数据管理和分析；</p>
    <p class="textIndentation">（3）信息咨询及交易管理服务；</p>
    <p class="textIndentation">（4）通知提醒服务；</p>
    <p class="textIndentation">（5）与合作机构协同，提供健康管理信息；</p>
    <p class="textIndentation">（6）其他相关服务。</p>
    <p class="textIndentation">2.4平台为用户提供服务的具体内容以相关业务规则和指引、服务协议或使用手册为准。用户使用平台提供的服务时，自行签署的法律文件不得违反平台已有的相关业务规则和指引、服务协议或使用手册。</p>
    <p class="textIndentation">2.5用户成为正式用户后，即主动授权平台通过合作机构开放接口获取其检查数据，设立平台账号，该账户可以进行智能化数据分析和历次数据存储管理，并这些服务付费。<strong>平台的所有检查数据，实际通过具有医疗资质的合作机构检查获取，平台不增加或修改这些数据，平台进行的分析只是在检查数据上的自动化分析，进行的并非医学评估，不能替代医疗诊断。用户通过平台进行上述操作，并在此不可撤销地授权平台按照本协议及其他已阅读并同意的平台业务规则和指引或其签署的法律文本向合作机构发出关于管理个人检查数据的指令。平台及合作机构将共同保障用户数据安全和服务的完整。</strong></p>
    <p class="textIndentation"><strong>2.6为更好地提供用户服务，中科知心可能会委托相关合作方为用户提供一部分用户服务而无须经过用户的同意（法律法规强制要求取得用户授权的除外）或特别告知用户；对此，用户完全理解并予以同意。</strong></p>
    <p class="textIndentation">2.7用户应自行准备上网设备，包括但不限于移动电话、计算机、调制解调器或其他必备的上网装置以及能够支持中科知心正常运行的软件系统，并保证上网设备的安全性及自行承担上网开支，包括但不限于网络接入费、手机流量费等费用。如因用户设备、系统软件安全性及上网费用等原因导致无法接收或使用中科知心提供的技术服务，中科知心对此不承担任何责任。</p>
    <p class="textIndentation"><strong>第三条 用户管理</strong></p>
    <p class="textIndentation">3.1中科知心只接受在中国（就本协议的目的，不包含中国香港特别行政区、澳门特别行政区和台湾地区）注册成立，且有权订立具有法律约束力协议的企业法人或其他经济组织成为正式用户。如果不符合资格，用户需停止在中科知心上的任何操作行为。</p>
    <p class="textIndentation">3.2<strong>用户申请成为中科知心用户时，应按照提示要求向中科知心提供真实、准确、完整、合法有效的注册及认证资料；当用户的注册资料发生变动时，应及时通知中科知心进行更新。因用户提供的资料、信息不真实、不完整，则任何因此导致用户不能正常使用中科知心功能或服务的，中科知心对此不承担任何责任</strong>。如果涉及用户信息变动的，用户根据中科知心的要求提出申请，经中科知心在3个工作日内审核后生效。用户应保证其诸如电子邮件地址、联系电话、联系地址等内容的有效性及安全性。一旦中科知心及中科知心其他用户向用户注册资料中提供的地址、邮箱、联系电话发送通知即视为已向该用户送达。<strong>如果用户提供的注册资料不合法、不真实、不准确、不详尽，用户须承担因此引起的相应责任及后果，并且中科知心有权在发送注销通知30日后，注销用户的用户账户，终止用户使用中科知心服务的权利。</strong></p>
    <p class="textIndentation">3.3在成功绑定或注册成为中科知心正式用户后，用户即获得其设置的用户账户，用户账户是用户登录中科知心的唯一账户。登录中科知心时用户应当使用用户账户、用户设定并保管的密码和（或）手机验证码或者其他允许的方式进行登录；为保护用户的权益，用户在设定用户账户密码时，请使用符合中科知心要求的密码策略；中科知心会和微信绑定，即微信登陆进入中科知心，视为客户登录完成，用户可在用户登陆状态下进行服务绑定和支付，微信支付风险为微信平台承担。用户应妥善保管用户的账户信息，因保管不善而造成的经济损失由用户自行承担；用户授权中科知心向数字证书服务机构申请电子签章数字证书、为用户开通数字证书账户，作为用户在中科知心签署电子合同的电子签章证书。</p>
    <p class="textIndentation">3.4用户需绑定手机号码完成注册，请用户使用指定的手机号码（用户为自然人的使用本人实名制号码）进行注册，中科知心将根据需求对用户的手机号码的真实性与一致性进行验证，用户亦可根据需求申请更换您的手机号码，中科知心验证通过后会以验证通过的用户手机号码绑定您的账号而无需事先通知用户。用户使用其自身的用户账号、用户设定手机验证码或者其他平台允许的方式登录平台后在平台的一切行为均代表该用户并由该用户承担相应的法律后果。中科知心对用户账号的遗失或被盗所产生的后果不承担任何责任。</p>
    <p class="textIndentation">3.5<strong>用户同意并认可中科知心可以通过系统消息、平台公告、邮件、短信（含中科知心委托的第三方短信服务）、电话、微信等形式，向用户发送通知。用户同意将其通过中科知心微信公众号入口首次登录平台或在平台注册时使用的微信与用户账号绑定，作为用户指定微信用于接收中科知心发送的信息。中科知心可在合理范围内收集、使用该等微信昵称、OpenID等微信相关信息。</strong></p>
    <p class="textIndentation"><strong>第四条 用户权利与义务</strong></p>
    <p class="textIndentation">4.1<strong>用户绑定或注册开通账户、下载或直接使用中科知心软件或平台服务的，即表示用户已同意《隐私及信息保护政策》、本协议、平台业务规则和指引及用户服务的项目和内容等。</strong></p>
    <p class="textIndentation">4.2用户通过在中科知心绑定或注册的账号、用户设定并保管的密码和（或）手机验证码或者其他平台允许的方式输入相关信息进行登录，<strong>用户在应用软件上做出的任何操作行为，均不得撤回或撤销，且成为应用软件向用户提供有关交易服务的唯一指令。</strong></p>
    <p class="textIndentation">4.3 各方具体业务内容由各方自行确定，平台仅提供信息服务。但其具体业务内容不得违反平台已有的相关业务规则和指引、服务协议或使用手册。</p>
    <p class="textIndentation">4.4 <strong>中科知心与合作机构等医疗机构合作为用户提供相关服务，但是，中科知心本身并不是合作机构等医疗机构，中科知心向用户提供的服务也非医疗业务，本协议项下的检查诊断均通过医疗机构来实现，用户理解并同意其医疗诊断、药品等服务需要发生在医疗体系中，并按照医疗公布的收费标准缴另行支付费用，中科知心只对这个过程信息的部分反馈进行公示，并不对此类信息的准确性负责。中科知心不对非中科知心原因造成的技术故障、信息安全措施等事件导致的用户损失承担责任。</strong></p>
    <p class="textIndentation">4.5<strong>在用户成为中科知心正式用户时，用户授权中科知心可通过合作医疗机构或向第三方机构收集用户相关资料（包括但不限于体检系统/PACS系统/HIS系统/中医系统等的业务信息、用户的检查就诊信息等个人基本信息，社会公共信息、各类健康行为信息、第三方提供的健康评测信息等其他信息），以核实用户身份、身体状态、健康风险等方面的真实状况。中科知心可向合作机构等披露相关信息，但仅可提供用户授权范围内及为提供服务而必要使用的信息。如遇特殊情况或政府机关、监管机构等第三方机构需要提供资料，中科知心有权向用户收集相关资料并提供，用户理解并会予以配合。</strong></p>
    <p class="textIndentation">4.6若用户未遵从本协议或相关业务规则和指引，则中科知心有权拒绝为用户提供相关服务，由此产生的损害由用户自行承担。</p>
    <p class="textIndentation">4.7<strong>因用户的过错导致的损失，应由用户自行承担责任，该过错包括但不限于：不按照本协议、中科知心的业务规则和指引操作，未及时进行中科知心操作，遗忘或泄漏密码，密码被他人破解，用户使用的计算机被他人侵入等。</strong></p>
    <p class="textIndentation">4.8如中科知心发生了因系统故障或其他任何原因导致的处理错误，中科知心有权纠正该错误。</p>
    <p class="textIndentation">4.9 中科知心所涉及到的任何款项只以人民币计结，中科知心不提供任何形式的汇兑业务。</p>
    <p class="textIndentation">4.10用户在使用中科知心的过程中，本协议及相关业务规则和指引共同构成中科知心的使用规则。若用户使用本协议或业务规则和指引中所涉及的交易服务项目，即表示用户同意并接受各项规则所规定的相关内容约束。用户对前述任一协议、规则的违背均构成用户对中科知心的违约，应当承担相应的法律责任。</p>
    <p class="textIndentation">4.11<strong>为了准确核验用户的身份，尽量防止用户的身份被冒用，用户授权中科知心可以采集用户的设备信息以验证用户在进行认证时是否处于可信环境（包括物理环境与网络环境），并收集用户法定代表人的人脸照片或证件照片信息。</strong> </p>
    <p class="textIndentation"><strong>第五条 服务费用</strong></p>
    <p class="textIndentation">5.1<strong>在用户接受中科知心提供的服务时，同意中科知心有权向用户收取相关服务费用，中科知心拥有制定及调整服务费用的权利。</strong>具体服务费用以用户使用中科知心提供的服务时，用户与中科知心达成的交易协议为准。</p>
    <p class="textIndentation">5.2用户在使用中科知心服务过程中可能需要向第三方（如合作医疗主体、健康管理公司或食品公司等）支付付费并享有三方对应服务，此部分费用不含盖中科知心服务收费中。具体收取标准以用户使用中科知心提供的交易服务时，中科知心、第三方公示的收取标准或用户与第三方达成的其他协议为准，收费方式也遵守三方建议方式，不限于中科知心代收。</p>
    <p class="textIndentation">5.3除非另有说明或约定，用户同意中科知心向支付公司发出从用户专属账号中直接扣收上述款项的指令，实际扣收金额以用户确认的相关业务合同约定为准。</p>
    <p class="textIndentation"><strong>第六条 中科知心的服务限制与服务终止</strong></p>
    <p class="textIndentation">6.1<strong>用户理解并同意中科知心有权基于法律法规及监管要求等原因中断一项或多项服务，除法律另有规定外，中科知心无义务对任何个人或第三方负责。</strong></p>
    <p class="textIndentation">6.2若用户违反本协议的约定，中科知心有权暂停或终止向用户提供服务。</p>
    <p class="textIndentation">6.3在中科知心发现用户操作异常，或中科知心对用户的操作有疑问，或中科知心认为用户的操作有违反法律法规规定、本协议及相关业务规则和指引时，中科知心可对用户采取特殊限制措施（包括但不限于对用户账号下未完成的操作采取取消、暂停服务等），并通过系统消息的形式通知用户。</p>
    <p class="textIndentation">6.4 如用户从事下列行为的，中科知心有权终止向用户提供服务并有权追究因此遭受的全部损失：对中科知心进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现源代码；对中科知心拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；对中科知心运行过程中释放到任何终端内存中的数据、运行过程中客户端与服务器端的交互数据，以及本平台运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经运营方授权的第三方工具/服务接入中科知心和相关系统；通过修改或伪造中科知心运行中的指令、数据，增加、删减、变动的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；通过非运营方开发、授权、合作的第三方软件、插件、外挂、系统，登录或使用中科知心及服务，或制作、发布、传播上述工具；自行或者授权他人、第三方软件对中科知心及其组件、模块、数据进行干扰。</p>
    <p class="textIndentation"><strong>第七条 用户注销</strong></p>
    <p class="textIndentation">7.1如用户需要注销其在平台注册的用户账户，应首先清偿所有应付款项（包括但不限于借款本金、利息、罚息、违约金、服务费、管理费、第三方费用等），再将用户账户中的可用款项（如有）全部提现至该用户专属账号外的同名银行账户，或者向平台发出其他合法的支付指令，并向平台申请注销该用户账户，经平台审核同意后可正式注销用户账户。</p>
    <p class="textIndentation">7.2平台注销该注册用户账户，即表明平台与用户之间的服务协议已解除，但用户仍应对使用平台服务期间的行为承担可能的违约或损害赔偿责任，同时平台仍可在合法范围和期限内保有用户的相关资料和交易数据。</p>
    <p class="textIndentation"><strong>第八条 责任范围及责任限制</strong></p>
    <p class="textIndentation">8.1<strong>平台仅对本协议中列明的责任范围承担责任。运营方、平台及平台的董事、员工、代理人均不以任何明示或默示的方式对用户通过平台形成的交易及其履行提供任何担保</strong>。用户应基于自己的判断决定是否与其他方进行交易，并自行承担相应的后果。平台在此提示，平台已经充分地向用户陈述此类责任承担问题，用户注册并使用应用软件的行为表明该用户已明了并接受平台关于此类责任的划分。</p>
    <p class="textIndentation">8.1平台仅对本协议中列明的责任范围承担责任。运营方、平台及平台的董事、员工、代理人均不以任何明示或默示的方式对用户通过平台形成的交易及其履行提供任何担保。用户应基于自己的判断决定是否与其他方进行交易，并自行承担相应的后果。平台在此提示，平台已经充分地向用户陈述此类责任承担问题，用户注册并使用应用软件的行为表明该用户已明了并接受平台关于此类责任的划分。</p>
    <p class="textIndentation">8.3如因不可抗力或其他中科知心无法控制的原因使中科知心程序崩溃或无法正常使用导致中科知心操作无法完成或丢失有关的信息、记录等，中科知心会合理地尽力协助处理善后事宜，但中科知心不对因此导致的任何损害赔偿（包括但不限于利润、商誉、使用、数据等方面的损失或其他无形损失）承担责任。前述情形包括但不限于：</p>
    <p class="textIndentation">（1）因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力因素，造成中科知心系统障碍不能执行业务的；</p>
    <p class="textIndentation">（2）中科知心运维系统停机维护的；</p>
    <p class="textIndentation">（3）电信设备出现故障不能进行数据传输的；</p>
    <p class="textIndentation">（4）由于黑客攻击、网络供应商技术调整或故障、网站升级、合作机构方面的问题等原因而造成的中科知心服务中断或延迟的。</p>
    <p class="textIndentation"><strong>第九条 隐私权保护及授权</strong></p>
    <p class="textIndentation">9.1中科知心可以根据用户在中科知心上的行为自动记录相关用户的某些资料。在不违反法律法规和本协议的前提下，<strong>中科知心有权对整个用户数据库进行分析并对用户数据库进行商业上的合理利用。</strong></p>
    <p class="textIndentation">9.2中科知心可以使用用户的相关资料，包括但不限于中科知心持有的有关用户的档案中的资料，以及中科知心通过其他方式自行收集的资料，中科知心可通过人工或自动程序对用户的资料进行评价，中科知心的合作伙伴为提供本协议项下服务可对用户信息和资料进行查询、收集或进行信息数据分析。为确保用户信息的安全，中科知心将依照法律法规规定的要求对上述信息负有保密义务，并采取各种措施保证信息安全。</p>
    <p class="textIndentation">9.3<strong>中科知心根据法律法规的规定对用户的信息保密，中科知心不会披露给任何第三方，但以下情况除外：</strong></p>
    <p class="textIndentation">（1）向独立服务且仅要求服务相关的必要信息的第三方，如印刷厂、邮递公司等提供用户信息；</p>
    <p class="textIndentation">（2）向具有合法调阅信息权限并从合法渠道调阅信息的司法部门或其他政府机构提供用户信息；</p>
    <p class="textIndentation">（3）向中科知心的关联实体提供用户信息；</p>
    <p class="textIndentation">（4）向中科知心的合作方提供用户信息；</p>
    <p class="textIndentation">（5) 向合作医疗机构提供申请方的用户信息；</p>
    <p class="textIndentation">（6）向经用户同意的第三方提供用户信息。</p>
    <p class="textIndentation">9.4<strong>为更好的向用户提供中科知心服务，用户授权并且同意运营方通过合法方式从合法持有用户信息的第三方主体处收集用户的信息，且同意中科知心将查询收集的用户信息进行存储、加工、共享，并用于如下用途：</strong></p>
    <p class="textIndentation"><strong>(1)评价用户健康情况、核实用户信息的真实性，以更好地掌握用户情况；</strong></p>
    <p class="textIndentation"><strong>(2)创建数据分析模型，为用户提供符合用户健康风险状况、健康管理过程状况的中科知心服务；</strong></p>
    <p class="textIndentation"><strong>(3)为解决用户与中科知心、其他用户之间的争议而将用户信息提供给法律顾问、法院、仲裁委员会和其他机构；</strong></p>
    <p class="textIndentation"><strong>(4)预防或阻止非法活动，确保用户在中科知心进行安全交易；</strong></p>
    <p class="textIndentation"><strong>(5)向用户推送与中科知心服务有关的通知提醒，如（服务到期提醒、预约活动提醒）；</strong></p>
    <p class="textIndentation"><strong>(6)为履行法律法规的强制性要求而留存、备份系统信息的副本；</strong></p>
    <p class="textIndentation"><strong>(7)其他经用户同意的用途。</strong></p>
    <p class="textIndentation">9.5经国家生效法律文书或行政处罚决定确认用户存在违法行为，或者中科知心有足够事实依据可以认定用户存在违法或违反本协议的行为，中科知心有权在中科知心上公布用户的违法、违约行为，并将有关行为记入与用户相关的档案。</p>
    <p class="textIndentation"><strong>第十条 知识产权</strong></p>
    <p class="textIndentation">10.1运营方拥有中科知心内容及资源的知识产权等合法权利，受国家法律保护。</p>
    <p class="textIndentation">10.2除法律另有强制性规定外，未经中科知心明确的特别书面许可,任何单位不得以任何方式非法全部或部分复制、转载、引用、链接、抓取或以其他方式使用本站的信息内容，否则，中科知心有权追究其法律责任。</p>
    <p class="textIndentation">10.3中科知心所刊登的资料信息（诸如文本、图表、标识、设计、源代码、图像、声音文件片段、数字下载、数据编辑和软件），均是中科知心或其内容提供者的财产，受中国和国际版权公约的保护。中科知心上所有内容的汇编是中科知心的排他财产，受中国和国际版权公约的保护。中科知心上所有软件都是中科知心或其关联公司或其软件供应商的财产，受中国和国际版权公约的保护。未经中科知心书面同意，不得将中科知心包含的资料等任何内容镜像到任何其他网站或者服务器。任何未经授权对中科知心内容的使用均属于违法行为，中科知心将追究其法律责任。</p>
    <p class="textIndentation">10.4<strong>用户不得利用中科知心服务从事侵害他人权益或违法之行为，若有违反者应负所有法律责任。上述行为包括但不限于：</strong></p>
    <p class="textIndentation">（1）反对宪法所确定的基本原则，危害国家安全、泄漏国家秘密、颠覆国家政权、破坏国家统一的；</p>
    <p class="textIndentation">（2）侵害他人人格权、财产权、商业秘密、商标权、著作权、专利权、其他知识产权及其他权益；</p>
    <p class="textIndentation">（3）违反依法律或合约所应负之保密义务；</p>
    <p class="textIndentation">（4）冒用他人名义使用中科知心平台服务；</p>
    <p class="textIndentation">（5）从事任何不法交易行为，如贩卖枪支、毒品、禁药、盗版软件或其他违禁物；</p>
    <p class="textIndentation">（6）提供赌博资讯或以任何方式引诱他人参与赌博；</p>
    <p class="textIndentation">（7）涉嫌洗钱、套现或进行传销活动的；</p>
    <p class="textIndentation">（8）从事任何可能含有电脑病毒或是可能侵害中科知心服务系統、资料等行为；</p>
    <p class="textIndentation">（9）利用中科知心服务系统进行可能对互联网或移动网正常运转造成不利影响之行为；</p>
    <p class="textIndentation">（10）利用中科知心服务上传、展示或传播虚假的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料；</p>
    <p class="textIndentation">（11）使用中科知心提供的服务或其他电子邮件转发服务发出垃圾邮件或其他可能违反本协议的内容。</p>
    <p class="textIndentation"><strong>第十一条 通知</strong></p>
    <p class="textIndentation">本协议项下的通知如以公告方式作出，一经在中科知心站内弹窗或站内信息即视为已经送达。除此之外，其他向用户发布的具有专属性的通知将由中科知心向用户通过系统消息、或在注册时或者注册后变更用户信息时向中科知心提供的电子邮箱，或中科知心正式用户在中科知心绑定的手机发送，或与用户账户绑定的微信发送，一经发送即视为已经送达。请用户密切关注中科知心的系统消息、用户的电子邮箱中的邮件和信息及手机中的短信信息、微信信息。</p>
    <p class="textIndentation"><strong>第十二条 适用法律及争议解决</strong></p>
    <p class="textIndentation">12.1本协议适用中华人民共和国大陆地区有效法律（就本协议之目的，不包含中国香港特别行政区、澳门特别行政区和台湾地区的法律）。如发生本协议或中科知心的业务规则和指引与中华人民共和国法律法规相抵触，则这些内容将完全按法律规定重新解释，而其他条款则依旧保持对用户的约束力。</p>
    <p class="textIndentation">12.2若用户和中科知心就本协议的订立和履行等事宜产生争议的，用户和中科知心应首先协商解决；协商不成，可向企业归属地所在地有管辖权的人民法院起诉。</p>
    <p class="textIndentation"><strong>第十三条 其他</strong></p>
    <p class="textIndentation">13.1本协议由本协议条款与中科知心的相关业务规则和指引组成，本协议中未尽事宜应按照相关法律法规及中科知心的相关业务规则和指引办理。</p>
    <p class="textIndentation">13.2<strong>本协议不涉及用户之间因网上交易而产生的法律关系及法律纠纷，中科知心原则上不介入用户之间的交易纠纷，但可协助用户查明交易情况。</strong></p>
    <p class="textIndentation">13.3用户同意遵守《中华人民共和国电子签名法》，全面接受和履行与中科知心其他用户在中科知心签订的任何电子法律文本，并承诺按该法律文本享有和/或放弃相应的权利、承担和/或豁免相应的义务；用户所有的签署行为已获得授权，具有法律效力。</p>
    <p class="textIndentation">13.4如非特别指明，本协议条款均适用于中科知心所有企业注册用户。</p>
    <p class="textIndentation">13.5如本协议或网站规则条款中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其他条款的有效性和可执行性。</p>
    <p class="textIndentation">13.6中科知心的运营方，有权代表中科知心从事对外签署协议等相关民事行为，享有中科知心在本协议项下的权利并履行中科知心在本协议项下的义务。<strong>运营方对本协议拥有最终的解释权。</strong></p>
    <!--van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }"></van-divider>
        <van-row>
              <van-col offset="1" span="9"><van-checkbox v-model="state.Informed.informedFlag">我已经仔细阅读并同意上述内容</van-checkbox></van-col>
        </van-row-->
    <br />
  </div>
  <br />

  <van-button round color="linear-gradient(to right, #f67f34, #d55809)" size="large" @click="changeInformed">返回</van-button>

  <van-overlay :show="showOverlay" @click="showOverlay = false">
    <div class="wrapper" @click.stop>
      <div class="block">
        <van-cell-group inset>
          <van-notice-bar wrapable :scrollable="false" text="您未做机构绑定" left-icon="info-o" />
          <p class="textIndentationoverlay"><van-notice-bar wrapable :scrollable="false" color="#1989fa"
              background="#ffffff" text="目前仅开放体检机构定向邀约客户绑定。您可以向体检机构获取【邀约码】。" /></p>
          <van-button type="warning" block plain hairline to="about">
            返回项目介绍
          </van-button>
        </van-cell-group>
      </div>
    </div>
  </van-overlay>
  <van-overlay :show="showBinging" @click="showBinging = false">
    <div class="wrapper" @click.stop>
      <div class="block">
        <van-cell-group inset>
          <van-notice-bar wrapable :scrollable="false" text="绑定确认中" left-icon="info-o" />
          <p class="textIndentationoverlay"><van-notice-bar wrapable :scrollable="false" color="#1989fa"
              background="#ffffff" text="您提交的绑定需要【3-5个工作日】确认" /></p>
          <van-button type="warning" block plain hairline to="about">
            返回项目介绍
          </van-button>
        </van-cell-group>
      </div>
    </div>
  </van-overlay>
</template>
<script>

import { ref, onMounted, reactive } from 'vue';
import { getCheckBinding, getCheckInformed } from '../../api/permission'
//import { postChangeInformed } from '../../api/register'
import { useRouter } from 'vue-router';
import { postUserLog } from "../../api/userlog";
export default ({
  setup() {
    const showOverlay = ref(false);
    const showBinging = ref(false);
    const router = useRouter();
    const ulog = reactive({
            UserLog: {
                 path: "",
            },
        });
    const state = reactive({
      Informed: {
        informedFlag: '',
      }
    });
    const changeInformed = () => {
      router.back();
    }
    onMounted(() => {
      ulog.UserLog.path = router.currentRoute.value.fullPath;
      console.log("当前页面路径==" + ulog.UserLog.path);
      postUserLog(ulog.UserLog).then(() => {});
      console.log('页面打开')
      state.Informed.informedFlag = false;
      getCheckBinding().then((res1) => {
        console.log(res1.data.code);
        const binding = res1.data.code;
        if (binding == 60001) {
          showOverlay.value = false;
        } else if (binding == 60002) {
          showBinging.value = true;
        } else {
          showOverlay.value = false;
        }
      })
      getCheckInformed().then((res) => {
        console.log(res.data.code);
        const binding = res.data.code;
        if (binding == 70001) {
          state.Informed.informedFlag = true;
        } else if (binding == 70002) {
          state.Informed.informedFlag = false;
        } else {
          state.Informed.informedFlag = false;
        }
      })
    })
    return {
      showOverlay,
      showBinging,
      state,
      changeInformed
    };
  },
})
</script>

<style lang="less" scoped>
.example {
  font-size: 18px;
  display: block;

}

.oddRoundElement {
  border-radius: 12px 12px;
  font-size: 14px;
  margin: 0 20px;
  background: #FFF;
  color: #000;
}

.textTitalIndentation {
  font-size: 14px;
  text-align: left;
  padding-top: 1em;
  padding-right: 1em;
  padding-left: 1em;
}

.textIndentation {
  font-size: 14px;
  text-align: left;
  padding-right: 1em;
  padding-left: 1em;
}

.text2DIndentation {
  font-size: 14px;
  text-align: left;
  text-indent: 2em;
  padding-right: 1em;
  padding-left: 1em;
}

.textIndentationoverlay {
  font-size: 12px;
  text-align: left;
  margin-top: 10px;

}

.spanCheckbox {
  text-align: left;
  margin-top: 10px;

}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 500px;
  height: 400px;
}</style>
